'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { changeLanguage } from '@eliadmin/core/src/server/api-client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export function LanguageSelect() {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingLocale, setLoadingLocale] = useState<string | null>(null);
  const locale = useLocaleStore(s => s.currentLocale);
  const locales = useLocaleStore(s => s.supportedLocales);
  const [selectedLocale, setSelectedLocale] = useState(
    locales.find(localeIterator => localeIterator.locale === locale),
  );
  const pathname = usePathname();

  const handleLocaleChange = async (newLocale: string) => {
    if (newLocale === locale) return;

    let newRoute = `/${newLocale}${pathname}`;
    if (pathname.startsWith(`/${locale}`)) {
      newRoute = pathname.replace(`/${locale}`, `/${newLocale}`);
    }
    setIsLoading(true);
    setLoadingLocale(newLocale);
    await changeLanguage({ locale: newLocale });
    window.location.replace(newRoute);
  };

  useEffect(() => {
    setSelectedLocale(locales.find(localeIterator => localeIterator.locale === locale));
  }, [locale]);

  return (
    <div className={cn('flex items-center gap-6')}>
      {locales.map(localeItem => {
        const isActive = localeItem.locale === locale;
        const isLoadingThisLocale = isLoading && loadingLocale === localeItem.locale;
        return (
          <div
            key={`${localeItem.name}-${localeItem.locale}`}
            className="relative flex h-8 w-8 items-center justify-center"
          >
            <Image
              src={localeItem?.image?.url ?? '/images/placeholder.png'}
              alt={resolveImageAlt(localeItem?.image, localeItem?.locale)}
              onClick={() => handleLocaleChange(localeItem.locale)}
              fill
              className={cn(
                'absolute inset-0 z-[1] h-full w-full cursor-pointer object-contain object-center transition-opacity duration-200',
                isActive ? 'opacity-100' : 'opacity-50',
              )}
            />
            {isLoadingThisLocale && (
              <div className="absolute inset-0 z-10 flex items-center justify-center">
                <Spinner />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
